/* Fragrances Bazaar · Smell the World · v1.1 discovery tools
   Scent profile (header badge, "Matches your profile", quiz email tags), Compare, Layer it with…, Note Atlas,
   Smells-like finder, WhatsApp concierge and share buttons. Loaded after theme.js; every module is isolated. */
(() => {
  'use strict';
  const FB = window.FBTheme || {};
  const D = FB.discovery || {};
  const S = D.strings || {};
  const R = FB.routes || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const api = () => FB.api || {};
  const store = {
    get(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } },
    del(k) { try { localStorage.removeItem(k); } catch (e) { /* private mode */ } }
  };
  const K_PROFILE = 'fb:profile:v1', K_GIFT = 'fb:gift:v1', K_PENDING = 'fb:quiz:pending', K_CMP = 'fb:compare:v1';
  const readJSON = el => { try { return el ? JSON.parse(el.textContent || 'null') : null; } catch (e) { return null; } };
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scent families (same keywords and tints as snippets/family-tint) ---------- */
  const FAMS = [['leather', /leather|oud/i, '#8A4A6C'], ['fresh', /citrus|fresh/i, '#E6D684'], ['aquatic', /aquatic|marine|ocean/i, '#8DBAB3'],
    ['floral', /floral|flower/i, '#D9A2A5'], ['fruity', /fruit/i, '#D0745F'], ['gourmand', /gourmand|sweet/i, '#C58E52'],
    ['woody', /wood/i, '#7C8B66'], ['amber', /amber|oriental/i, '#BC6A2F'], ['aromatic', /aromatic|foug/i, '#9D93B8']];
  const famKey = name => { const f = FAMS.find(x => x[1].test(name || '')); return f ? f[0] : String(name || '').trim().toLowerCase(); };
  const famTint = name => { const f = FAMS.find(x => x[1].test(name || '')) || FAMS.find(x => x[0] === name); return f ? f[2] : '#C8A04A'; };

  /* ---------- notes: canonical key, display name, note family ---------- */
  const STRIP = /\b(absolute|absolu|essence|extract|accord|oil|notes?|co2|orpur|calabrian|sicilian|italian|florentine|indian|egyptian|bourbon|madagascar|haitian|virginia|guatemala|egypt|indonesia|honeyed|juicy|wild|toffee|chocolate|crystals|sambac|zest|coulis|petals|roasted|white|dry|from|india|of india)\b/g;
  const ALIAS = { cedar: 'cedarwood', cassis: 'blackcurrant', 'blackcurrant bud': 'blackcurrant', 'black currant': 'blackcurrant', peppermint: 'mint',
    'ylang ylang': 'ylang-ylang', 'orange flower': 'orange blossom', tonka: 'tonka bean', 'oak moss': 'oakmoss', waterlily: 'water lily', jasmin: 'jasmine',
    'ambery woods': 'amberwood', 'pink peppercorn': 'pink pepper', 'black pepper': 'pepper', 'green mandarin': 'mandarin', 'green apple': 'apple',
    'violet apple': 'apple', 'pink peony': 'peony', pralines: 'praline', 'vanilla bean': 'vanilla', 'vanilla seed': 'vanilla', cashmere: 'cashmere wood',
    'woody notes': 'woods', woody: 'woods', wood: 'woods', 'oriental spices': 'spices', 'woody musk': 'musk', 'violet leaves': 'violet leaf', 'sea salt': 'sea salt',
    'coffee': 'coffee', 'jasmin petals': 'jasmine', 'bamboo leaves': 'bamboo', 'peach musk': 'peach', 'tiare': 'tiare flower', 'cedar wood': 'cedarwood' };
  const norm = s => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[™®©*]/g, '');
  const noteKey = raw => {
    let s = norm(raw).replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
    if (!s) return '';
    if (ALIAS[s]) s = ALIAS[s];
    let t = s.replace(STRIP, ' ').replace(/\s+/g, ' ').trim() || s;
    if (ALIAS[t]) t = ALIAS[t];
    return t.replace(/\s+/g, '-');
  };
  const keyName = k => k === 'ylang-ylang' ? 'Ylang-ylang' : (k.charAt(0).toUpperCase() + k.slice(1)).replace(/-/g, ' ');
  const NOTE_FAMS = ['Citrus', 'Floral', 'Fruity', 'Green & Aromatic', 'Spicy', 'Woody', 'Amber & Resin', 'Gourmand', 'Musk & Animalic', 'Aquatic & Mineral', 'Leather & Smoke'];
  const NF_TINT = { 'Citrus': '#E6D684', 'Floral': '#D9A2A5', 'Fruity': '#D0745F', 'Green & Aromatic': '#9D93B8', 'Spicy': '#BC6A2F', 'Woody': '#7C8B66', 'Amber & Resin': '#C8A04A', 'Gourmand': '#C58E52', 'Musk & Animalic': '#CBB9A8', 'Aquatic & Mineral': '#8DBAB3', 'Leather & Smoke': '#8A4A6C' };
  const KNOWN = {
    'Citrus': 'lemon bergamot mandarin tangerine clementine grapefruit orange bitter-orange neroli petitgrain lime yuzu citrus',
    'Floral': 'jasmine rose peony orange-blossom iris geranium freesia osmanthus honeysuckle tiare-flower tuberose ylang-ylang heliotrope violet hyacinth lily-of-the-valley water-lily sand-lily daisy flowers magnolia gardenia orchid mimosa lotus lily',
    'Fruity': 'blackcurrant peach apple pear plum raspberry cranberry lychee pineapple melon apricot exotic-fruits fig red-currant-leaf berries cherry strawberry',
    'Green & Aromatic': 'lavender oakmoss moss sage rosemary mint armoise verbena violet-leaf tea green-tea mate bamboo juniper fir basil thyme green galbanum',
    'Spicy': 'pink-pepper cinnamon pepper cardamom saffron ginger nutmeg spices clove cumin',
    'Woody': 'sandalwood cedarwood patchouli vetiver woods cashmere-wood amberwood cashmeran amberketal guaiac',
    'Amber & Resin': 'amber labdanum benzoin myrrh olibanum',
    'Gourmand': 'vanilla tonka-bean caramel praline milk honey cocoa coffee toast sugar cotton-candy hazelnut coconut chestnut coumarin almond bitter-almond',
    'Musk & Animalic': 'musk ambergris ambrox',
    'Aquatic & Mineral': 'sea-salt sea-grass mineral marine ozonic',
    'Leather & Smoke': 'leather suede oud tobacco incense smoke'
  };
  const KNOWN_MAP = {};
  Object.entries(KNOWN).forEach(([f, list]) => list.split(' ').forEach(k => { KNOWN_MAP[k] = f; }));
  const splitNotes = str => String(str || '').split(/,|;|\s+and\s+|\s&\s/i).map(s => s.replace(/\.$/, '').trim()).filter(s => s && s.length < 48);
  const tiersOf = n => { const t = String(n || '').split('||'); return [splitNotes(t[0]), splitNotes(t[1]), splitNotes(t[2])]; };

  /* parse "Top: … / Heart: … / Base: …" out of a description (used when the compare-data section is not available) */
  function notesFromHtml(html) {
    const txt = String(html || '').replace(/<(br|\/p|\/li|\/dt|\/dd|\/div|\/h\d|\/strong|\/b)[^>]*>/gi, ' | ').replace(/<[^>]+>/g, ' ').replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ');
    const grab = labels => { const m = txt.match(new RegExp('(?:^|\\|)\\s*(?:' + labels + ')(?:\\s+notes?)?\\s*:?\\s*(?:\\|\\s*)*([^|]*[^|\\s][^|]*)', 'i')); return m ? m[1].trim().replace(/\.$/, '') : ''; };
    return [grab('top|head'), grab('heart|middle|mid'), grab('base')].join('||');
  }

  /* ---------- small UI helpers ---------- */
  const fmt = (str, map) => Object.keys(map).reduce((s, k) => s.split(k).join(map[k]), String(str || ''));
  function announce(el, msg) { if (!el) return; el.textContent = ''; setTimeout(() => { el.textContent = msg; }, 30); }
  let toastT;
  function toast(msg) {
    let t = $('.fb-toast');
    if (!t) { t = document.createElement('div'); t.className = 'fb-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('on'), 2400);
  }
  async function addItems(items) {
    const res = await fetch((R.cartAdd || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: location.pathname })
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) throw new Error(data.description || data.message || (FB.strings && FB.strings.error) || 'Error');
    const A = api();
    if (A.useDrawer && A.useDrawer()) {
      let h = data.sections && data.sections['cart-drawer'];
      if (!h && A.fetchDrawerSection) h = await A.fetchDrawerSection();
      try { A.renderDrawer && A.renderDrawer(h); } catch (e) { /* drawer markup changed */ }
      A.openCart && A.openCart();
      fetch((R.cart || '/cart') + '.js').then(r => r.json()).then(c => { A.updateCount && A.updateCount(c.item_count); document.dispatchEvent(new CustomEvent('fb:cart:updated', { detail: { cart: c } })); }).catch(() => {});
    } else {
      location.href = R.cart || '/cart';
    }
    document.dispatchEvent(new CustomEvent('fb:cart:added', { detail: { items } }));
  }

  /* =========================================================
     SCENT PROFILE
     ========================================================= */
  const profile = () => (D.profile === false ? null : store.get(K_PROFILE));
  function initProfile() {
    if (D.profile === false) return;
    document.addEventListener('fb:quiz:result', e => {
      const d = e.detail || {};
      const rec = { key: d.key, name: d.name, url: d.url, runner: d.runner || '', runnerName: d.runnerName || '', ts: Date.now() };
      if (d.mode === 'gift') store.set(K_GIFT, rec); else store.set(K_PROFILE, rec);
      setQuizTags(d.quiz, d);
      document.dispatchEvent(new CustomEvent('fb:profile:change'));
    });
    document.addEventListener('submit', e => {
      const f = e.target.closest && e.target.closest('[data-quiz-email]'); if (!f) return;
      const q = f.closest('[data-quiz]'); const last = q && q._fbLast;
      if (last) store.set(K_PENDING, { key: last.key, mode: last.mode, runner: last.runner, ts: Date.now() });
    }, true);
    document.addEventListener('fb:profile:change', () => { renderBadge(); markCards(); });
    restoreQuiz();
    renderBadge(); markCards();
    let t; new MutationObserver(ms => {
      if (!ms.some(m => Array.from(m.addedNodes).some(n => n.nodeType === 1 && (n.matches('.card') || n.querySelector('.card'))))) return;
      clearTimeout(t); t = setTimeout(markCards, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
  function setQuizTags(q, d) {
    const inp = q && $('[data-quiz-tags]', q); if (!inp) return;
    const k = String(d.key || '').replace(/[^a-z0-9-]/gi, '').toLowerCase();
    inp.value = d.mode === 'gift' ? `newsletter, quiz, gift-shopper, scent-gift-${k}` : `newsletter, quiz, scent-${k}`;
  }
  /* after "Email me my matches" posts, Shopify reloads the page: show the same result again with the success message */
  function restoreQuiz() {
    const q = $('[data-quiz]'); if (!q || !q._fbShowResult) return;
    const posted = $('[data-quiz-posted]', q) || /customer_posted=true/.test(location.search);
    const errs = $('[data-quiz-email] .nl-msg--err', q);
    const pend = store.get(K_PENDING);
    if ((!posted && !errs) || !pend || Date.now() - (pend.ts || 0) > 30 * 60 * 1000) return;
    q._fbShowResult(pend.key, pend.mode, pend.runner);
    setQuizTags(q, pend);
    if (posted) store.del(K_PENDING);
    const f = $('[data-quiz-email]', q); f && f.scrollIntoView({ block: 'center', behavior: RM ? 'auto' : 'smooth' });
  }
  let badgeDocBound = false;
  function renderBadge() {
    const p = profile();
    let slot = $('[data-profile]');
    if (!slot) { const tools = $('.hdr__tools'); if (!tools) return; slot = document.createElement('div'); slot.className = 'prof'; slot.setAttribute('data-profile', ''); tools.prepend(slot); }
    if (!p || !p.name) { slot.hidden = true; slot.innerHTML = ''; return; }
    const tint = famTint(p.name) !== '#C8A04A' ? famTint(p.name) : famTint(p.key);
    slot.hidden = false;
    slot.innerHTML = `<button type="button" class="prof__b" aria-expanded="false" aria-controls="prof-pop" title="${esc(S.yourFamily)}: ${esc(p.name)}"><i style="background:${tint}"></i><span class="prof__n">${esc(p.name)}</span><span class="sr-only">, ${esc(S.yourFamily)}</span></button>
      <div class="prof__pop" id="prof-pop" hidden>
        <span class="prof__e">${esc(S.yourFamily)}</span>
        <b class="prof__f"><i style="background:${tint}"></i>${esc(p.name)}</b>
        ${p.url ? `<a class="btn btn--ink prof__shop" href="${esc(p.url)}">${esc(fmt(S.shopFamily, { '%s': p.name }))}</a>` : ''}
        <a class="prof__l" href="${esc(D.quizUrl || '/pages/find-your-scent')}">${esc(S.retake)}</a>
        <button type="button" class="prof__l" data-profile-forget>${esc(S.forget)}</button>
      </div>`;
    const b = $('.prof__b', slot), pop = $('.prof__pop', slot);
    b.addEventListener('click', ev => { ev.stopPropagation(); const open = pop.hidden; pop.hidden = !open; b.setAttribute('aria-expanded', open); if (open) { const f = $('a,button', pop); f && f.focus(); } });
    pop.addEventListener('click', ev => ev.stopPropagation());
    if (!badgeDocBound) {
      badgeDocBound = true;
      const close = () => { const pp = $('.prof__pop'), bb = $('.prof__b'); if (pp && !pp.hidden) { pp.hidden = true; bb && bb.setAttribute('aria-expanded', 'false'); return true; } return false; };
      document.addEventListener('click', close);
      document.addEventListener('keydown', ev => { if (ev.key === 'Escape' && close()) { const bb = $('.prof__b'); bb && bb.focus(); } });
    }
    $('[data-profile-forget]', slot).addEventListener('click', () => { store.del(K_PROFILE); document.dispatchEvent(new CustomEvent('fb:profile:change')); });
  }
  function cardFamily(card) { if (card.dataset.family) return card.dataset.family; const f = $('.card__fam', card); return f ? f.textContent.trim() : ''; }
  function markCards() {
    const p = profile();
    $$('.card__match, .pdp-match').forEach(el => el.remove());
    if (!p || !p.key) return;
    $$('.card').forEach(card => {
      const fam = cardFamily(card); if (!fam || famKey(fam) !== p.key) return;
      const body = $('.card__body', card); if (!body) return;
      const tag = document.createElement('span'); tag.className = 'card__match'; tag.innerHTML = `<i aria-hidden="true">✦</i>${esc(S.match)}`;
      body.prepend(tag);
    });
    const pdp = $('[data-product][data-family]') || $('[data-product]');
    if (pdp) {
      const chip = $('.fam-chip', pdp); const fam = pdp.dataset.family || (chip ? chip.textContent.trim() : '');
      if (fam && famKey(fam) === p.key && chip) { const t = document.createElement('span'); t.className = 'pdp-match'; t.innerHTML = `<i aria-hidden="true">✦</i>${esc(S.match)}`; chip.after(t); }
    }
  }

  /* =========================================================
     COMPARE (2–3 products)
     ========================================================= */
  const cache = new Map();
  const cmpList = () => (store.get(K_CMP) || []).filter(x => x && x.h).slice(0, 3);
  function initCompare() {
    if (D.compare === false) return;
    const drawer = $('[data-compare-drawer]');
    document.addEventListener('click', e => {
      const t = e.target.closest('[data-compare-toggle]');
      if (t) { e.preventDefault(); toggleCompare(t); return; }
      if (e.target.closest('[data-compare-open]')) { openCompare(); return; }
      if (e.target.closest('[data-compare-clear]')) { store.set(K_CMP, []); syncCompare(); return; }
      if (e.target.closest('[data-compare-close]')) { closeCompare(); return; }
      const rm = e.target.closest('[data-compare-remove]');
      if (rm) { store.set(K_CMP, cmpList().filter(x => x.h !== rm.dataset.compareRemove)); syncCompare(); if (drawer && !drawer.hidden) { if (cmpList().length) renderCompare(); else closeCompare(); } return; }
      const add = e.target.closest('[data-compare-add-bag]');
      if (add) { add.classList.add('is-loading'); addItems([{ id: +add.dataset.compareAddBag, quantity: 1 }]).then(closeCompare).catch(err => toast(err.message)).finally(() => add.classList.remove('is-loading')); }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer && !drawer.hidden) closeCompare(); });
    window.addEventListener('storage', e => { if (e.key === K_CMP) syncCompare(); });
    new MutationObserver(() => syncToggles()).observe(document.body, { childList: true, subtree: true });
    syncCompare();
  }
  function itemFromToggle(t) {
    const card = t.closest('.card'), pdp = t.closest('[data-product]');
    const img = card ? $('.card__media img', card) : (pdp ? $('.pdp-media img', pdp) : null);
    return { h: t.dataset.compareToggle, t: t.dataset.title || (card ? ($('.card__n', card) || {}).textContent : '') || '', i: img ? (img.currentSrc || img.src) : '' };
  }
  function toggleCompare(t) {
    const list = cmpList(), h = t.dataset.compareToggle;
    if (list.some(x => x.h === h)) store.set(K_CMP, list.filter(x => x.h !== h));
    else if (list.length >= 3) { toast(S.compareFull); return; }
    else { list.push(itemFromToggle(t)); store.set(K_CMP, list); toast(S.compareAdded); }
    syncCompare();
  }
  function syncToggles() {
    const hs = cmpList().map(x => x.h);
    $$('[data-compare-toggle]').forEach(b => { const on = hs.includes(b.dataset.compareToggle); if (b.getAttribute('aria-pressed') !== String(on)) { b.setAttribute('aria-pressed', on); b.classList.toggle('is-on', on); } });
  }
  function syncCompare() {
    syncToggles();
    const tray = $('[data-compare-tray]'); if (!tray) return;
    const list = cmpList();
    tray.hidden = list.length === 0;
    document.body.classList.toggle('has-cmp-tray', list.length > 0);
    $('[data-compare-tray-list]', tray).innerHTML = list.map(x => `<li><span class="cmp-tray__img">${x.i ? `<img src="${esc(x.i)}" alt="">` : ''}</span><span class="cmp-tray__t">${esc(x.t)}</span><button type="button" data-compare-remove="${esc(x.h)}" aria-label="${esc(S.remove)}: ${esc(x.t)}">×</button></li>`).join('') +
      Array.from({ length: 3 - list.length }, () => '<li class="cmp-tray__ph" aria-hidden="true"><span class="cmp-tray__img"></span></li>').join('');
    const c = $('[data-compare-count]', tray); if (c) c.textContent = `(${list.length})`;
    const go = $('[data-compare-open]', tray); if (go) go.disabled = list.length < 2;
  }
  async function fetchCompare(h) {
    if (cache.has(h)) return cache.get(h);
    const base = (R.root || '/').replace(/\/$/, '');
    let d = null;
    try {
      const r = await fetch(`${base}/products/${encodeURIComponent(h)}?section_id=compare-data`);
      if (r.ok) d = readJSON(new DOMParser().parseFromString(await r.text(), 'text/html').querySelector('[data-compare-json]'));
    } catch (e) { d = null; }
    if (!d) {
      const r = await fetch(`${base}/products/${encodeURIComponent(h)}.js`);
      if (!r.ok) throw new Error('not found');
      const p = await r.json();
      const v = (p.variants || []).find(x => x.available) || (p.variants || [])[0] || {};
      const txt = String(p.description || '').replace(/<[^>]+>/g, ' ');
      const ml = (txt.match(/(\d+(?:\.\d+)?)\s?ml\b/i) || [])[0];
      const sizes = (p.variants || []).length > 1 ? p.variants.map(x => x.title).join(' · ') : (ml ? ml.replace(/\s/, '') : '');
      const card = $(`.card[data-handle="${CSS.escape(h)}"]`);
      const im = p.featured_image ? String(p.featured_image).replace(/^\/\//, 'https://') : '';
      d = { h, t: p.title, u: `/products/${h}`, v: p.vendor, i: im ? im + (im.includes('?') ? '&' : '?') + 'width=480' : '', p: (api().formatMoney ? api().formatMoney(p.price) : (p.price / 100).toFixed(2)) + '',
        f: card ? cardFamily(card) : '', n: notesFromHtml(p.description), c: p.type || '', z: sizes, s: '', x: ((p.title || '').match(/inspired by\s+(.+)$/i) || [])[1] || '', a: !!v.available, id: v.id };
    }
    cache.set(h, d); return d;
  }
  let cmpFocus = null;
  async function openCompare() {
    const drawer = $('[data-compare-drawer]'); if (!drawer || cmpList().length < 1) return;
    cmpFocus = document.activeElement;
    drawer.hidden = false; requestAnimationFrame(() => drawer.classList.add('open'));
    document.body.style.overflow = 'hidden';
    const x = $('.cmp__top [data-compare-close]', drawer); x && x.focus();
    await renderCompare();
  }
  function closeCompare() {
    const drawer = $('[data-compare-drawer]'); if (!drawer || drawer.hidden) return;
    drawer.classList.remove('open'); document.body.style.overflow = '';
    setTimeout(() => { drawer.hidden = true; }, RM ? 0 : 350);
    if (cmpFocus && cmpFocus.focus) cmpFocus.focus();
  }
  async function renderCompare() {
    const grid = $('[data-compare-grid]'); if (!grid) return;
    const list = cmpList();
    grid.style.setProperty('--n', list.length);
    grid.innerHTML = list.map(() => '<div class="cmp__col is-loading"><span class="cmp__sk"></span></div>').join('');
    const data = await Promise.all(list.map(x => fetchCompare(x.h).catch(() => ({ h: x.h, t: x.t, i: x.i, u: `/products/${x.h}` }))));
    const tiers = data.map(d => tiersOf(d.n).map(t => t.map(noteKey)));
    const allKeys = data.map((d, i) => new Set(tiers[i].flat()));
    const shared = k => allKeys.filter(s => s.has(k)).length > 1;
    const row = (label, val) => `<div class="cmp__row"><span class="cmp__lbl">${esc(label)}</span><span class="cmp__val">${val || '<span class="cmp__na">–</span>'}</span></div>`;
    const chips = arr => arr.length ? arr.map(n => { const k = noteKey(n); return `<span class="cmp__chip${shared(k) ? ' is-shared' : ''}"${shared(k) ? ` title="${esc(S.shared)}"` : ''}>${esc(n)}</span>`; }).join('') : '';
    grid.innerHTML = data.map(d => {
      const [t, h, b] = tiersOf(d.n);
      return `<div class="cmp__col">
        <button type="button" class="cmp__rm" data-compare-remove="${esc(d.h)}" aria-label="${esc(S.remove)}: ${esc(d.t)}">×</button>
        <a class="cmp__media" href="${esc(d.u)}">${d.i ? `<img src="${esc(d.i)}" alt="" loading="lazy">` : ''}</a>
        ${d.v ? `<span class="card__v">${esc(d.v)}</span>` : ''}
        <a class="cmp__n" href="${esc(d.u)}">${esc(d.t)}</a>
        ${row(S.price, d.p ? `<b>${esc(d.p)}</b>` : '')}
        ${row(S.family, d.f ? `<span class="cmp__fam"><i style="background:${famTint(d.f)}"></i>${esc(d.f)}</span>` : '')}
        ${row(S.conc, esc(d.c || ''))}
        ${row(S.size, esc(d.z || ''))}
        ${row(S.top, chips(t))}
        ${row(S.heart, chips(h))}
        ${row(S.base, chips(b))}
        ${row(S.place, d.s ? `<span class="pstamp pstamp--card pstamp--inline"><span class="pstamp__lbl"><i>✦</i>${esc(d.s.split(',')[0].toUpperCase())}${d.s.includes(',') ? `<em>${esc(d.s.split(',').slice(1).join(',').trim().toUpperCase())}</em>` : ''}</span></span>` : '')}
        ${row(S.insp, esc(d.x || ''))}
        ${d.id && d.a ? `<button type="button" class="btn btn--ink cmp__add" data-compare-add-bag="${esc(d.id)}">${esc(S.addToBag)}</button>` : `<a class="btn btn--ghost cmp__add" href="${esc(d.u)}">${esc(S.view)}</a>`}
      </div>`;
    }).join('');
  }

  /* =========================================================
     LAYER IT WITH… : add both bottles in one request
     ========================================================= */
  function initLayer() {
    document.addEventListener('click', async e => {
      const b = e.target.closest('[data-layer-add]'); if (!b || b.disabled) return;
      const sec = b.closest('[data-product]') || document;
      const vid = $('[data-product-form] [data-variant-id]', sec) || $('form[action*="/cart/add"] [name=id]', sec);
      const err = $('[data-layer-error]', b.closest('[data-layer]') || sec);
      if (!vid) return;
      const A = api();
      A.loading ? A.loading([b], true) : b.classList.add('is-loading');
      if (err) { err.hidden = true; err.textContent = ''; }
      try { await addItems([{ id: +vid.value, quantity: 1 }, { id: +b.dataset.partner, quantity: 1 }]); }
      catch (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } }
      finally { A.loading ? A.loading([b], false) : b.classList.remove('is-loading'); }
    });
  }

  /* =========================================================
     NOTE ATLAS
     ========================================================= */
  function buildNotes(index, seed, entries) {
    const notes = new Map(), aliasTo = {};
    const meta = {};
    Object.entries(seed || {}).forEach(([h, v]) => { meta[h] = { n: v.n, f: v.f, d: v.d, o: v.o, img: '', url: '' }; (v.a || []).forEach(a => { aliasTo[noteKey(a)] = h; }); });
    (entries || []).forEach(e => { const h = noteKey(e.n || e.h) || e.h; meta[h] = Object.assign(meta[h] || {}, { n: e.n || (meta[h] || {}).n, f: e.f || (meta[h] || {}).f, d: e.d || (meta[h] || {}).d, o: e.o || (meta[h] || {}).o, img: e.img || '', url: e.url || '' }); if (e.h && e.h !== h) aliasTo[e.h] = h; String(e.a || '').split('|').filter(Boolean).forEach(a => { aliasTo[noteKey(a)] = h; }); });
    const canon = k => aliasTo[k] || k;
    const get = k => { if (!notes.has(k)) { const m = meta[k] || {}; notes.set(k, { k, n: m.n || keyName(k), f: m.f || KNOWN_MAP[k] || '', d: m.d || '', o: m.o || '', img: m.img || '', url: m.url || '', ps: [], tier: [0, 0, 0] }); } return notes.get(k); };
    (index || []).forEach(p => {
      const seen = new Set();
      tiersOf(p.n).forEach((arr, ti) => arr.forEach(raw => { const k = canon(noteKey(raw)); if (!k || seen.has(k)) return; seen.add(k); const n = get(k); n.ps.push(p); n.tier[ti]++; }));
    });
    Object.keys(meta).forEach(k => { if (meta[k].url || (entries || []).length) get(k); });
    return { notes, canon };
  }
  function miniCard(p) {
    return `<a class="mini" href="${esc(p.u)}"><div class="mini__arch">${p.i ? `<img src="${esc(p.i)}" alt="" loading="lazy">` : ''}</div><div class="mini__t">${esc(p.v)}</div><div class="mini__n">${esc(p.t)}</div><div class="mini__p">${esc(p.p)}</div></a>`;
  }
  function initAtlas() {
    const root = $('[data-atlas]'); if (!root || root.dataset.fbInit) return; root.dataset.fbInit = '1';
    const index = readJSON($('[data-disc-index]', root)) || [];
    const { notes, canon } = buildNotes(index, readJSON($('[data-note-seed]', root)), readJSON($('[data-note-entries]', root)));
    const groupsEl = $('[data-atlas-groups]', root), famsEl = $('[data-atlas-fams]', root), empty = $('[data-atlas-empty]', root);
    const tools = $('[data-atlas-tools]', root), qIn = $('[data-atlas-q]', root);
    const panel = $('[data-atlas-panel]', root), pBody = $('[data-atlas-panel-body]', root);
    const list = Array.from(notes.values()).filter(n => n.ps.length || n.url).sort((a, b) => a.n.localeCompare(b.n));
    let view = 'family';
    if (tools) tools.hidden = false;
    const tile = n => `<button type="button" class="atl__tile" data-key="${esc(n.k)}" style="--nt:${NF_TINT[n.f] || '#C8A04A'}"><span class="atl__tn">${esc(n.n)}${n.d ? '<i aria-hidden="true">✦</i>' : ''}</span><span class="atl__tc">${n.ps.length === 1 ? esc(S.scentOne) : esc(fmt(S.scents, { '%n': n.ps.length }))}</span></button>`;
    function render() {
      const q = norm(qIn ? qIn.value : '').trim();
      const shown = list.filter(n => !q || norm(n.n).includes(q));
      let groups;
      if (view === 'az') {
        groups = []; shown.forEach(n => { const L = n.n.charAt(0).toUpperCase(); let g = groups.find(x => x.name === L); if (!g) groups.push(g = { name: L, id: 'atl-l-' + L, items: [] }); g.items.push(n); });
      } else {
        groups = NOTE_FAMS.concat(['']).map(f => ({ name: f || S.moreNotes, f, id: 'atl-f-' + (f || 'more').toLowerCase().replace(/[^a-z]+/g, '-'), items: shown.filter(n => (n.f || '') === f || (!f && !NOTE_FAMS.includes(n.f))) })).filter(g => g.items.length);
      }
      groupsEl.innerHTML = groups.map(g => `<section class="atl__grp" id="${g.id}" aria-labelledby="${g.id}-h"><h2 class="atl__gh" id="${g.id}-h">${view === 'family' ? `<i style="background:${NF_TINT[g.f] || '#C8A04A'}"></i>` : ''}${esc(g.name)}<span>${g.items.length}</span></h2><div class="atl__tiles">${g.items.map(tile).join('')}</div></section>`).join('');
      famsEl.hidden = !groups.length;
      famsEl.innerHTML = groups.map(g => `<a href="#${g.id}">${view === 'family' ? `<i style="background:${NF_TINT[g.f] || '#C8A04A'}"></i>` : ''}${esc(g.name)}</a>`).join('');
      empty.hidden = !!groups.length;
    }
    function openNote(k, push) {
      const n = notes.get(canon(noteKey(k))) || notes.get(k); if (!n) return;
      const hid = panel.getAttribute('aria-labelledby');
      const filt = D.filterLinks || root.dataset.filterLinks === '1';
      const tiers = ['top', 'heart', 'base'];
      const mainTier = tiers[n.tier.indexOf(Math.max(...n.tier))] || 'top';
      const fUrl = `${root.dataset.allUrl || '/collections/all'}?filter.p.m.${root.dataset.ns || 'custom'}.${mainTier}_notes=${encodeURIComponent(n.n)}`;
      pBody.innerHTML = `<div class="atl-p" style="--nt:${NF_TINT[n.f] || '#C8A04A'}">
        ${n.img ? `<img class="atl-p__img" src="${esc(n.img)}" alt="">` : `<span class="atl-p__seal" aria-hidden="true"><em>${esc(n.n.charAt(0))}</em></span>`}
        ${n.f ? `<span class="eyebrow atl-p__fam"><i></i>${esc(n.f)}</span>` : ''}
        <h2 id="${hid}" class="atl-p__h">${esc(n.n)}</h2>
        ${n.d ? `<p class="atl-p__d">${esc(n.d)}</p>` : ''}
        ${n.o ? `<p class="atl-p__o"><b>${esc(S.origin)}</b> ${esc(n.o)}</p>` : ''}
        <p class="atl-p__tiers">${n.tier.map((c, i) => c ? `<span>${esc(S[tiers[i]] || tiers[i])} · ${c}</span>` : '').join('')}</p>
        ${n.ps.length ? `<h3 class="atl-p__sub">${esc(fmt(S.foundIn, { '%s': n.n }))}</h3><div class="bottles3 atl-p__grid">${n.ps.map(miniCard).join('')}</div>` : ''}
        <div class="fq__ctas">${n.url ? `<a class="btn" href="${esc(n.url)}">${esc(S.notePage)}</a>` : ''}${filt ? `<a class="btn-txt" style="color:var(--gold-2)" href="${esc(fUrl)}">${esc(fmt(S.shopNote, { '%s': n.n }))}</a>` : ''}</div>
      </div>`;
      panel.hidden = false; requestAnimationFrame(() => panel.classList.add('open'));
      document.body.style.overflow = 'hidden';
      const x = $('.atl-panel__x', panel); x && x.focus();
      if (push !== false) { const u = new URL(location.href); u.searchParams.set('note', n.k); history.replaceState(null, '', u); }
    }
    let lastTile = null;
    function closeNote() {
      if (panel.hidden) return;
      panel.classList.remove('open'); document.body.style.overflow = '';
      setTimeout(() => { panel.hidden = true; }, RM ? 0 : 350);
      const u = new URL(location.href); u.searchParams.delete('note'); history.replaceState(null, '', u);
      if (lastTile && document.contains(lastTile)) lastTile.focus();
    }
    root.addEventListener('click', e => {
      const t = e.target.closest('.atl__tile'); if (t) { lastTile = t; openNote(t.dataset.key); return; }
      if (e.target.closest('[data-atlas-close]')) closeNote();
      const v = e.target.closest('[data-atlas-view]');
      if (v) { view = v.dataset.atlasView; $$('[data-atlas-view]', root).forEach(b => b.setAttribute('aria-pressed', b === v)); render(); }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) closeNote(); });
    qIn && qIn.addEventListener('input', render);
    render();
    const want = new URLSearchParams(location.search).get('note');
    if (want) openNote(want, false);
  }

  /* =========================================================
     SMELLS-LIKE FINDER
     ========================================================= */
  const STOP = new Set(['eau', 'de', 'du', 'parfum', 'toilette', 'edp', 'edt', 'for', 'women', 'men', 'woman', 'man', 'her', 'him', 'by', 'the', 'perfume', 'fragrance', 'cologne', 'spray', 'ml', 'oz', 'pour', 'homme', 'femme', 'inspired', 'a', 'an']);
  const words = s => norm(s).replace(/[’'`!.]/g, '').replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(w => w && !STOP.has(w));
  function lev(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    const m = Array.from({ length: a.length + 1 }, (_, i) => [i]);
    for (let j = 1; j <= b.length; j++) m[0][j] = j;
    for (let i = 1; i <= a.length; i++) for (let j = 1; j <= b.length; j++) m[i][j] = Math.min(m[i - 1][j] + 1, m[i][j - 1] + 1, m[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    return m[a.length][b.length];
  }
  // rough sound-alike key so common misspellings still match ("midnite" ~ "midnight", "fantom" ~ "phantom", "sauvag" ~ "sauvage")
  const sk = w => w.replace(/ght/g, 't').replace(/ph/g, 'f').replace(/ck/g, 'k').replace(/y/g, 'i').replace(/(.)\1+/g, '$1').replace(/e$/, '');
  const wMatch = (q, t) => t === q || (q.length >= 3 && t.startsWith(q)) || (q.length >= 5 && lev(q, t) <= 1) || (q.length >= 8 && lev(q, t) <= 2) ||
    (q.length >= 4 && (sk(q) === sk(t) || (sk(q).length >= 5 && lev(sk(q), sk(t)) <= 1)));
  function score(q, target) {
    const qt = words(q), tt = words(target); if (!qt.length || !tt.length) return 0;
    const hit = qt.filter(w => tt.some(t => wMatch(w, t))).length / qt.length;
    const cov = tt.filter(t => qt.some(w => wMatch(w, t))).length / tt.length;
    return hit + cov * 0.3 + (words(target).join(' ').includes(qt.join(' ')) ? 0.5 : 0);
  }
  function initSmells() {
    const root = $('[data-smells]'); if (!root || root.dataset.fbInit) return; root.dataset.fbInit = '1';
    const idx = readJSON($('[data-disc-index]', root)) || [];
    const str = readJSON($('[data-smells-strings]', root)) || {};
    const aliases = {};
    String(readJSON($('[data-smells-aliases]', root)) || '').split(/\n/).forEach(l => { const [a, b] = l.split('='); if (a && b) aliases[words(a).join(' ')] = b.trim(); });
    const items = idx.map(p => { let x = p.x; if (!x) { const m = String(p.t).match(/inspired by\s+(.+)$/i); if (m) x = m[1].trim(); } return Object.assign({}, p, { x }); });
    const insp = items.filter(p => p.x);
    const form = $('[data-smells-form]', root), qIn = $('[data-smells-q]', root), out = $('[data-smells-results]', root), none = $('[data-smells-none]', root);
    const names = Array.from(new Set(insp.map(p => p.x))).sort();
    const dl = $('[data-smells-list]', root); if (dl) dl.innerHTML = names.map(n => `<option value="${esc(n)}"></option>`).join('');
    const tryEl = $('[data-smells-try]', root);
    if (tryEl && names.length) { tryEl.hidden = false; tryEl.insertAdjacentHTML('beforeend', names.slice(0, 6).map(n => `<button type="button" class="chip" data-smells-pick="${esc(n)}">${esc(n)}</button>`).join('')); }
    const card = (p, label) => {
      const top = tiersOf(p.n)[0].slice(0, 3).join(' · ');
      return `<article class="sml-card"><a class="sml-card__m" href="${esc(p.u)}" tabindex="-1" aria-hidden="true">${p.i ? `<img src="${esc(p.i)}" alt="" loading="lazy">` : ''}</a>
        <div class="sml-card__b"><span class="sml-card__e">${esc(label)}</span>${p.v ? `<span class="card__v">${esc(p.v)}</span>` : ''}
        <a class="sml-card__n" href="${esc(p.u)}">${esc(p.t)}</a>
        ${p.x ? `<span class="sml-card__x">${esc(fmt(str.insp, { '%s': p.x }))}</span>` : ''}
        ${p.f ? `<span class="card__fam"><i style="background:${famTint(p.f)}"></i>${esc(p.f)}</span>` : ''}
        ${top ? `<span class="sml-card__nt">${esc(top)}</span>` : ''}
        <div class="sml-card__f"><b>${esc(p.p)}</b><a class="btn btn--ink" href="${esc(p.u)}">${esc(str.view || S.view)}</a>${D.compare !== false ? `<button class="cmp-tog cmp-tog--inline" type="button" aria-pressed="false" data-compare-toggle="${esc(p.h)}" data-title="${esc(p.t)}"><span aria-hidden="true" class="cmp-tog__i"></span><span class="cmp-tog__t">${esc(S.compare)}</span></button>` : ''}</div></div></article>`;
    };
    function run(q, updateUrl) {
      q = String(q || '').trim(); root.dataset.query = q;
      if (!q) { out.innerHTML = ''; none.hidden = true; if (updateUrl) { const u = new URL(location.href); u.searchParams.delete('q'); history.replaceState(null, '', u); } return; }
      const aq = aliases[words(q).join(' ')] || q;
      const m = insp.map(p => ({ p, s: Math.max(score(aq, p.x), score(q, p.x)) })).filter(x => x.s >= 0.75).sort((a, b) => b.s - a.s);
      const o = items.filter(p => !p.x && p.n !== undefined).map(p => ({ p, s: score(aq, p.t) })).filter(x => x.s >= 1.0).sort((a, b) => b.s - a.s).slice(0, 4);
      out.innerHTML = (m.length ? `<p class="sml__count">${esc(fmt(m.length === 1 ? (str.countOne || '%n match') : str.count, { '%n': m.length }))}</p><div class="sml__grid">${m.map(x => card(x.p, str.ours)).join('')}</div>` : '') +
        (o.length ? `<h2 class="sml__h2">${esc(str.original)}</h2><div class="sml__grid">${o.map(x => card(x.p, str.original)).join('')}</div>` : '');
      none.hidden = !!(m.length || o.length);
      document.dispatchEvent(new CustomEvent('fb:smells:search', { detail: { q } }));
      syncToggles();
      if (updateUrl) { const u = new URL(location.href); u.searchParams.set('q', q); history.replaceState(null, '', u); }
    }
    form && form.addEventListener('submit', e => { e.preventDefault(); clearTimeout(liveT); run(qIn.value, true); });
    // live results while typing: 250 ms after the last keystroke, once there are 2+ characters (clearing the box clears results)
    let liveT, lastQ = '';
    qIn && qIn.addEventListener('input', () => {
      clearTimeout(liveT);
      const v = qIn.value.trim();
      if (v.length > 0 && v.length < 2) return;
      liveT = setTimeout(() => { if (v === lastQ) return; lastQ = v; run(v, true); }, 250);
    });
    root.addEventListener('click', e => { const b = e.target.closest('[data-smells-pick]'); if (b) { qIn.value = b.dataset.smellsPick; run(qIn.value, true); } });
    const q0 = new URLSearchParams(location.search).get('q');
    if (q0) { qIn.value = q0; lastQ = q0.trim(); run(q0, false); }
  }

  /* =========================================================
     WHATSAPP CONCIERGE: product + saved quiz result in the pre-filled message
     ========================================================= */
  function initConcierge() {
    if (D.concierge === false) return;
    const msgFor = el => {
      const parts = [];
      const fab = $('.wa-fab');
      const preset = fab && fab.dataset.preset;
      parts.push(preset || D.waGreeting || 'Hi Fragrances Bazaar!');
      const pdp = $('[data-product]');
      let title = pdp && (pdp.dataset.productTitle || ($('h1', pdp) || {}).textContent);
      if (!title) { const og = $('meta[property="og:type"][content="product"]') && $('meta[property="og:title"]'); title = og && og.content; }
      if (title) parts.push(fmt(S.waProduct, { '%t': title.trim(), '%u': location.origin + location.pathname }));
      const sm = el && el.hasAttribute('data-wa-smells') && el.closest('[data-smells]');
      const q = el && el.closest('[data-quiz]'); const last = q && q._fbLast;
      if (sm && sm.dataset.query) parts.push(fmt(S.waSmells, { '%s': sm.dataset.query }));
      else if (last) parts.push(fmt(last.mode === 'gift' ? S.waGift : S.waProfile, { '%s': last.name }));
      else { const p = profile(); if (p && p.name) parts.push(fmt(S.waProfile, { '%s': p.name })); }
      return parts.join(' ');
    };
    const apply = el => {
      const m = (el.getAttribute('href') || '').match(/wa\.me\/(\d+)/); if (!m) return;
      el.setAttribute('href', `https://wa.me/${m[1]}?text=${encodeURIComponent(msgFor(el))}`);
    };
    const fab = $('.wa-fab');
    if (fab && !fab.dataset.preset) { const t = (fab.getAttribute('href') || '').match(/[?&]text=([^&]+)/); fab.dataset.preset = t ? decodeURIComponent(t[1].replace(/\+/g, ' ')) : ''; }
    const all = () => $$('.wa-fab, [data-wa-concierge]').forEach(apply);
    all();
    ['fb:profile:change', 'fb:quiz:result', 'fb:smells:search'].forEach(ev => document.addEventListener(ev, () => setTimeout(all, 0)));
    document.addEventListener('click', e => { const a = e.target.closest('.wa-fab, [data-wa-concierge]'); if (a) apply(a); }, true);
  }

  /* =========================================================
     SHARE BUTTONS: native share sheet + copy link
     ========================================================= */
  function initShare() {
    if (initShare.done) { $$('[data-share-native]').forEach(n => { if (navigator.share) n.hidden = false; }); return; }
    initShare.done = true;
    $$('[data-share]').forEach(w => {
      const nat = $('[data-share-native]', w);
      if (nat && navigator.share) nat.hidden = false;
    });
    document.addEventListener('click', async e => {
      const w = e.target.closest('[data-share]'); if (!w) return;
      const url = w.dataset.url || location.href, title = w.dataset.title || document.title;
      const msg = $('[data-share-msg]', w);
      if (e.target.closest('[data-share-native]')) { try { await navigator.share({ title, url }); } catch (err) { /* cancelled */ } return; }
      const c = e.target.closest('[data-share-copy]'); if (!c) return;
      let ok = false;
      try { await navigator.clipboard.writeText(url); ok = true; } catch (err) {
        const t = document.createElement('textarea'); t.value = url; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0'; document.body.appendChild(t); t.select();
        try { ok = document.execCommand('copy'); } catch (er) { ok = false; } t.remove();
      }
      if (ok) { c.classList.add('is-done'); announce(msg, c.dataset.copied || S.copied); setTimeout(() => { c.classList.remove('is-done'); if (msg) msg.textContent = ''; }, 2400); }
    });
  }

  /* ---------- init ---------- */
  const run = () => [initProfile, initCompare, initLayer, initAtlas, initSmells, initConcierge, initShare].forEach(fn => {
    try { fn(); } catch (err) { if (window.console) console.warn('[Fragrances Bazaar discovery]', fn.name, err); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', () => { try { syncCompare(); markCards(); initAtlas(); initSmells(); initShare(); } catch (e) { /* editor */ } });
  window.FBDiscovery = { noteKey, famKey, notesFromHtml, profile };
})();
